import { Banner } from '@sunwebgroup/uds-ui/banner'
import * as React from 'react'
import { useIntl } from 'react-intl'
import styles from './PaymentFullyPaidBanner.module.css'

export function PaymentFullyPaidBanner() {
  const { formatMessage } = useIntl()

  return (
    <div className={styles.wrapper}>
      <Banner
        color="informative"
        size="S"
        hasIcon
        contentIsCentered
      >
        <Banner.TextsWrapper>
          <Banner.Text>{formatMessage({ id: 'payment_scope_fully_paid_title' })}</Banner.Text>
          <Banner.SupportingText>{formatMessage({ id: 'payment_scope_fully_paid_description' })}</Banner.SupportingText>
        </Banner.TextsWrapper>
      </Banner>
    </div>
  )
}
